import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';

import type { WhatsNewStep } from '../../shared/whats-new.config';

@Component({
  selector: 'app-whats-new-step',
  imports: [TranslocoPipe],
  templateUrl: './whats-new-step.component.html',
  styleUrl: './whats-new-step.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WhatsNewStepComponent {
  readonly step = input.required<WhatsNewStep>();
}
